import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useIrzFacilityRequestChange } from './irz-facility-request-change-hook';
import { Process } from '../../components/process/process';
import { ProcessForm } from './irz-facility-request-change-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { TranslationKeys } from '../../enums';

const useStyles = makeStyles(() =>
  createStyles({
    loaderWrapper: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      padding: '10px',
    },
  })
);

export function IrzFacilityRequestChange() {
  const classes = useStyles();

  const { steps, isLoading } = useIrzFacilityRequestChange();

  return isLoading ? (
    <div className={classes.loaderWrapper}>
      <CircularProgress />
    </div>
  ) : (
    <Process<ProcessForm>
      title="Žádost o změnu údajů provozovny IRZ"
      steps={steps}
      translationKey={TranslationKeys.IRZ_FACILITY_REQUEST_CHANGE}
    />
  );
}
